import React, {useContext} from 'react';
import { Dialog, DialogProps } from '@mui/material'
import { BaseContentBox } from '@pokemon/design.ui.containers.base-content-box';
import { ModalContext } from './modal-context-provider';
import '@emotion/styled'
import '@emotion/react'

export interface BaseModalProps extends DialogProps {
  /**
   * Determines whether to use automatic breakpoint recognition from MUI, or let the consumer control it themselves.
   */
  overrideFullScreen?: boolean,
  /**
   * Determines whether to use the automatic modal open/close handling from the ModalContextProvider, or let the consumer control it themselves.
   */
  overrideOpen?: boolean,
  /**
   * Props to be passed to the content box component.
   */
  contentBoxProps: any,
  /**
   * Unique name prop for the modal, used when opening and closing.
   */
  name: string,
  /**
   * Only used as an override - unnecessary in most use cases.
   */
  open: boolean,
  /**
   * Only used as an override - unnecessary in most use cases.
   */
  fullScreen: boolean,
};

export function BaseModal(props: BaseModalProps) {
  const { name, open, fullScreen, overrideOpen, overrideFullScreen, PaperComponent, contentBoxProps, sx, children, ...otherProps} = props

  const {modalStatus, closeModal, mobileWidth} = useContext(ModalContext)

  if(!otherProps['aria-describedby'] && !otherProps['aria-labelledby']){
    console.error("You must provide either an aria-labelledby or aria-describedby property")
  }

  const finalFullScreen = overrideFullScreen ? fullScreen : mobileWidth
  const contentBox = PaperComponent || ((paperProps) => <BaseContentBox {...paperProps} customWidth={finalFullScreen ? '100%' : 420} {...contentBoxProps}/>)

  return (
    <Dialog 
      fullScreen={finalFullScreen}
      open={overrideOpen ? open : (modalStatus[name] || false)}
      onClose={() => closeModal(name)}
      PaperComponent={contentBox}
      sx={{
        " .base-container": finalFullScreen ? {
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem"
        } : {
          height: 'unset'
        },
        ...sx
      }}
      {...otherProps}
    >
      {children}
    </Dialog>
  );
}

BaseModal.defaultProps = {
  overrideFullScreen: false,
  overrideOpen: false,
  open: false,
  fullScreen: false,
  contentBoxProps: {}
}